const commonDe = {
    "restaurant": "Restaurant",
    "restaurant_not_found": "Das Restaurant ist nicht verfügbar.",
    "table_not_available": "An diesem Tisch können keine Bestellungen aufgegeben werden.",
    "note": "Notiz",
    "order": "Befehl",
    "internal_error": "Anfrage fehlgeschlagen. Der Server antwortete mit folgender Fehlermeldung:",
    "no_results": "Keine Ergebnisse",
    "cancel": "Stornieren",
    "save": "Speichern",
    "back": "Zurück",
    "search": "Suchen",
    "search_for_file_names": "Suche nach Dateinamen",
    "delete": "Löschen",
    "search_by_restaurant": "Restaurantsuche",
    "available": "Verfügbar",
    "unavailable": "Nicht verfügbar",
    "name": "Name",
    "status": "Status",
    "description": "Beschreibung",
    "price": "Preis",
    "add": "Hinzufügen",
    "phone": "Telefon",
    "internal_server_error": "Interner Serverfehler",
    "remove_all": "Alles löschen",
    "settings": "Einstellungen",
    "restaurant_name": "Restaurantname",
    "reservation_link": "Reservierungslink",
    "reservation_link_tooltip": "Es sind nur Links zum Reservierungssystem von Reserves zulässig.",
    "add_user": "Benutzer hinzufügen",
    "add_user_title": "Zugang zum Restaurant gewähren",
    "restaurant_users": "Nutzer mit Zugang zum Restaurant",
    "restaurant_description_hu": "Restaurantbeschreibung (ungarisch)",
    "restaurant_description_en": "Restaurantbeschreibung (Englisch)",
    "changes_saved": "Änderungen wurden erfolgreich gespeichert",
    "user_added_to_restaurant": "Dem Nutzer wurde der Zugang zum Restaurant gewährt.",
    "user_add_to_restaurant_tip": "Der Nutzer mit der angegebenen E-Mail-Adresse erhält Zugang zum ausgewählten Restaurant. Falls der Nutzer noch kein Konto besitzt, erhält er nach der Registrierung automatisch Zugang.",
    "sign_up_here": "Hier können Sie ein Konto erstellen.",
    "role_already_exists": "Der Nutzer mit dieser E-Mail-Adresse hat bereits Zugang zum Restaurant.",
    "error": "Fehler",
    "header_image": "Headerbild",
    "upload_image": "Bild hochladen",
    "image_not_set": "Bild nicht festgelegt",
    "validation": {
        "required": "Dieses Feld ist erforderlich",
        "optional": "Dieses Feld ist optional."
    },
    "hungary": "Ungarn",
    "date": "Datum",
    "close": "Schließen",
    "continue": "Weitermachen",
    "select_image": "Bild auswählen",
    "grant": "Gewähren",
    "restaurant_settings": "Restaurant-Einstellungen",
    "create_restaurant": "Restaurant gründen",
    "restaurant_created": "Restaurant erfolgreich gegründet",
    "restaurant_created_text": "Ihr Restaurant wurde erfolgreich erstellt. Sie können nun Menüpunkte hinzufügen und Ihre Restauranteinstellungen verwalten.",
    "continue_to_menu": "Weiter zur Menübearbeitung",
    "languages": {
        "hu": "ungarisch",
        "en": "Englisch",
        "de": "Deutsch",
        "fr": "Französisch",
        "sk": "slowakisch",
        "cz": "tschechisch",
        "pl": "Polieren",
        "si": "Slowenisch",
        "hr": "kroatisch",
        "ro": "rumänisch",
        "es": "Spanisch",
        "ru": "Russisch",
        "uk": "Ukrainisch",
        "he": "Hebräisch",
        "ja": "Japanisch",
        "ko": "Koreanisch"
    },
    "no_file_selected": "Keine Datei ausgewählt",
    "max_file_size": "Maximale Dateigröße:",
    "language": "Sprache",
    "google_analytics": "Google Analytics",
    "facebook_pixel": "Facebook-Pixel",
    "analytic_integration_premium_feature": "Die Integration von Analysetools ist Teil des PRO-Plans.",
    "refresh": "Aktualisieren",
    "address": "Adresse",
    "city": "Stadt",
    "postal_code": "Postleitzahl",
    "timezone": "Zeitzone",
    "country": "Land",
    "currency": "Währung",
    "currency_tooltip": "Dies ist nur für die Profileinstellungen erforderlich; unser System führt keine Finanztransaktionen in Ihrem Namen durch.",
    "or": "oder",
    "datachange_detected": "Datenänderung erkannt",
    "datachange_subtitle": "Das Menü, das Sie gerade bearbeiten, wurde seit dem Laden der Seite geändert.",
    "datachange_description": "Möchten Sie das Menü neu laden und Ihre Änderungen verlieren oder Ihre Version behalten und die anderen Änderungen überschreiben?",
    "datachange_refresh": "Seite neu laden, Änderungen gehen verloren",
    "datachange_overwrite": "Meine Version beibehalten, andere Änderungen überschreiben"
};

export default commonDe;
